<template>
  <main class="c-app-container">
    <quick-links v-if="showQuick && $store.state.auth.token"/>
    <!-- <transition name="fade" mode="out-in">
    </transition>-->
    <router-view :title="$route.params.title" :key="$route.fullPath"/>

    <side-panel v-if="showPanel">
      <router-view name="panel" :key="$route.fullPath"/>
    </side-panel>
  </main>
</template>

<script>
const QuickLinks = () => import('@/components/QuickLinks')
export default {
  name: "app-container",
  props: {
    showQuick: {
      type: Boolean,
      default: true
    },
  },
  components: {
    QuickLinks
  },
  computed: {
    showPanel() {
      return this.$store.state.showPanel;
    }
  }
};
</script>

<style lang="scss">
.c-app-container {
  // background: tint($colour-nhs-pale-grey, 60);
  padding: 0;
  max-width: 1400px;
  margin: 0 auto;

  @media screen and (min-width: 1024px) {
    padding: 1em;
    padding-bottom: 320px;
  }
}
</style>
